// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const formatCurrencyToShow = (value: any, format = false) => {
    if (!value || Number.isNaN(value)) return "";

    let newValue = value;
    if (format) {
        newValue = value?.replace(/\D/g, "");
        newValue /= 100;
    }
    return (
        Number(newValue)
            ?.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
            })
            ?.replace("R$", "") ?? ""
    );
};

export function parseCurrencyToNumber(maskedValue: string): number {
    const withoutMask = maskedValue.replace(/[^0-9,.]/g, "");
    const formated = withoutMask.replace(/\./g, "").replace(",", ".");
    return parseFloat(formated);
}
